import { z } from "zod";
export const taskStatusSchema = z.enum([
    "inbox",
    "today",
    "scheduled",
    "in_progress",
    "waiting",
    "done",
    "archived",
]);
export const taskPrioritySchema = z.enum(["critical", "high", "medium", "low"]);
export const taskDueTypeSchema = z.enum(["hard", "soft"]);
export const taskEffortSchema = z.enum(["tiny", "small", "medium", "large", "epic"]);
export const taskInputSchema = z.object({
    userId: z.string().min(1),
    title: z.string().min(1).max(500),
    description: z.string().max(5000).optional(),
    status: taskStatusSchema.default("inbox"),
    priority: taskPrioritySchema.default("medium"),
    projectId: z.string().optional(),
    areaId: z.string().optional(),
    tags: z.array(z.string()).default([]),
    dueDate: z.string().optional(),
    dueType: taskDueTypeSchema.optional(),
    scheduledDate: z.string().optional(),
    estimatedMinutes: z.number().int().positive().optional(),
    impact: z.number().int().min(1).max(5).optional(),
    effort: taskEffortSchema.optional(),
    reschedulingCount: z.number().int().min(0).default(0),
    aiPriority: taskPrioritySchema.optional(),
    blockedBy: z.array(z.string()).default([]),
    recurrence: z.string().optional(),
    consequenceOfDelay: z.string().optional(),
    aiNotes: z.string().optional(),
});
export const taskSchema = taskInputSchema.extend({
    id: z.string().min(1),
    createdAt: z.string().min(1),
    updatedAt: z.string().min(1),
});
//# sourceMappingURL=task.js.map